import { Button } from "@mui/material";
import { useContext } from "react";
import MyModal from "src/components/layout/MyModal";
import { GridContext } from "src/context/GridContext/GridContext";
import GridVehicleInfoModal_Attachment from "./layout/GridVehicleInfoModal_Attachment";
import { pvmStringLong } from "src/components/js/statics1";

export default function GridVehicleInfoModal() {
  const {
    isLoaded,
    gridVehicleInfoIsOpen,
    setGridVehicleInfoIsOpen,
    selectedGridVehicle,
    setSelectedGridVehicle,
    setSelectedVehicle,
  } = useContext(GridContext) || {};

  if (!isLoaded) return null;
  if (!gridVehicleInfoIsOpen) return null;
  if (!selectedGridVehicle) return null;
  if (selectedGridVehicle.vehicleId === 0) return null; // skip "KAIKKI" vehicle

  const handleClose = () => {
    setGridVehicleInfoIsOpen(false);
    setSelectedGridVehicle(null);
  };

  const handleEditVehicleClick = () => {
    setSelectedVehicle(selectedGridVehicle);
  };

  console.log("GridVehicleInfoModal", selectedGridVehicle);

  return (
    <MyModal
      isOpen={gridVehicleInfoIsOpen}
      onClose={handleClose}
      title={selectedGridVehicle?.vehicleRegNo}
      buttonSize="small">
      <div className="center" style={{ flexWrap: "wrap", gap: 10 }}>
        <GridVehicleInfoModal_Attachment />
        <div style={{ flex: 1 }}>
          <div>Numero: {selectedGridVehicle?.vehicleNo}</div>
          <div>Rekisteri: {selectedGridVehicle?.vehicleRegNo}</div>
          <div>Ajossa alkaen: {pvmStringLong(selectedGridVehicle?.firstDate)}</div>
          <div>Puomin pituus: {selectedGridVehicle?.vehiclePuomi}m</div>
          <div>Laji: {selectedGridVehicle?.vehicleTypeName}</div>
          <Button onClick={handleEditVehicleClick} variant="outlined" color="primary" size="small">
            <span style={{ fontSize: 14 }}>Muokkaa ajoneuvoa</span>
          </Button>
        </div>
      </div>
    </MyModal>
  );
}
